import { Box, Button, Grid, Typography } from "@mui/material";
import QuestionChoisesCard from "../../components/useCase/QuestionChoisesCard";
import GlobalInformationCard from "../../components/useCase/GlobalInformationsCard";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUseCaseById,
  addQuestionToUseCase,
  requestDeletingQuestion,
  openDeleteModal,
  closeDeleteModal,
} from "../../redux/actions/useCaseActionCreators";
import {
  getFormattedDay,
  getFormattedMonth,
  getFormattedYear,
  translate,
} from "../../utils/utils";
import DeleteDialog from "../../components/useCase/DeleteDialog";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router-dom";
import WeaknessesDetails from "../weaknesses/WeaknessesDetails";
import AddModal from "./AddModal";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useMediaQuery } from "@mui/material";

const MakeUseCase = () => {
  const { state } = useLocation();

  const [openWeaknessModal, setOpenWeaknessModal] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [isNewQuestion, setIsNewQuestion] = useState(state);
  const { t } = useTranslation();
  const useCaseData = useSelector((state) => state.useCase.selected);
  const dispatch = useDispatch();
  const params = useParams();
  const emptyQuestion = {
    title: "",
    title_fr: "",
    choices: [
      { title: "", title_fr: "", weight: null },
      { title: "", title_fr: "", weight: null },
      { title: "", title_fr: "", weight: null },
    ],
  };

  const id_owner = localStorage.getItem("orgaId");
  const storedUser = localStorage.getItem("user");
  const accountId = JSON.parse(storedUser)?.account_id;
  const accountType = JSON.parse(storedUser)?.account_type;
  useEffect(() => {
    dispatch(fetchUseCaseById(params.caseId));
  }, [dispatch, params.caseId]);

  const handleConfirmDeleteQuestion = () => {
    dispatch(requestDeletingQuestion(selectedQuestionId, params.caseId));
  };

  const handleDeleteQuestion = (id) => {
    dispatch(openDeleteModal());
    setSelectedQuestionId(id);
  };
  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <>
      {useCaseData && (
        <Box
          sx={{
            padding: "0px 20px 50px 20px",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{
              background:
                "linear-gradient(180deg, white 0%, white 90%, transparent 100%)",

              top: "0px",
              zIndex: "100",
              padding: "0px 0px",
            }}
          >
            <Grid item xs={11}>
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="title" sx={{ mb: "10px" }}>
                    {useCaseData?.[translate("title")] || [t("not_specified")]}
                  </Typography>

                  <Button
                    fullwidth
                    variant="outlined"
                    color="button"
                    size="small"
                    sx={{ marginLeft: "10px", mb: "10px" }}
                    onClick={(e) => {
                      setOpenEditModal(true);
                    }}
                  >
                    <ModeEditOutlineOutlinedIcon />
                  </Button>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: isMobile ? "row" : {},
                    flexWrap: "wrap",
                  }}
                >
                  <GlobalInformationCard
                    label={t("creator")}
                    value={useCaseData?.creator || "unknown"}
                  />
                  <GlobalInformationCard
                    label={t("threshold")}
                    value={`${useCaseData.threshold}`}
                  />
                  <GlobalInformationCard
                    label="Coefficient"
                    value={`${useCaseData.coefficient}`}
                  />
                  <GlobalInformationCard
                    label="Date"
                    value={`${getFormattedDay(
                      useCaseData?.last_update
                    )} ${getFormattedMonth(
                      useCaseData?.last_update
                    )} ${getFormattedYear(useCaseData?.last_update)}`}
                  />
                  <GlobalInformationCard
                    label={t("difficulty")}
                    value={t(useCaseData?.difficulty_level)}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={11}>
              <p>
                <span style={{ fontWeight: 600 }}>Description: </span>
                {useCaseData?.[translate("description")] || [
                  t("not_specified"),
                ]}
              </p>
              <p>
                <span style={{ fontWeight: 600 }}>
                  {t("related_weakness")}:{" "}
                </span>
                <span
                  onClick={() => setOpenWeaknessModal(true)}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  {useCaseData?.weakness?.[translate("title")] || [
                    t("not_specified"),
                  ]}
                </span>
              </p>
            </Grid>
            {useCaseData.questions?.map((ques, i) => (
              <Grid item xs={11} key={i}>
                <QuestionChoisesCard
                  handleDelete={handleDeleteQuestion}
                  questionData={ques}
                  index={i}
                  isNewQuestion={isNewQuestion}
                  threshold={useCaseData.threshold}
                  duplicated={state}
                />
              </Grid>
            ))}

            {/* <Grid item xs={10}  >
          <div style={{height:100,textAlign:"center",background:"#0000000d"}}>
        <Button
        color="secondary"
        variant="contained"
        startIcon={ <ControlPointIcon />}
        
        style={{marginTop:"30px"}}
                                        >
                                           
                                            New Question
                                        </Button>
                                        </div>
        </Grid> */}
            <Grid item xs={11}>
              <Grid
                style={{ background: "#0000000d", height: 100 }}
                container
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={!isMobile ? 3 : 8}>
                  <Button
                    color="secondary"
                    variant="contained"
                    fullWidth
                    startIcon={<ControlPointIcon />}
                    onClick={() => {
                      dispatch(addQuestionToUseCase(emptyQuestion));
                      setIsNewQuestion(true);
                    }}
                  >
                    {t("new_question")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DeleteDialog
            handleDelete={handleConfirmDeleteQuestion}
            description={t("would_you_like")}
            open={useCaseData.openDeleteModal}
            handleClose={() => dispatch(closeDeleteModal())}
            title={t("are_you_sure")}
            buttonLabel={t("remove_question")}
          />
          {useCaseData.weakness && (
            <WeaknessesDetails
              open={openWeaknessModal}
              handleClose={() => setOpenWeaknessModal(false)}
              rowDetails={useCaseData.weakness}
              id_owner={id_owner}
              company={JSON.parse(storedUser).entreprise}
            />
          )}
          <AddModal
            title={t("update_use_case")}
            usecaseId={useCaseData.id}
            open={openEditModal}
            handleClose={() => setOpenEditModal(false)}
            initialValues={{
              title: useCaseData?.[translate("title")],
              description: useCaseData?.[translate("description")],
              threshold: useCaseData.threshold,
              uc_coefficient: useCaseData.coefficient,
              related_weakness: useCaseData.weakness,
            }}
            difficulty={useCaseData?.difficulty_level}
            isUpdate
            accountId={accountId}
            accountType={accountType}
          />
        </Box>
      )}
    </>
  );
};

export default MakeUseCase;
